import React from "react";
import { AriaTextFieldProps, useTextField } from "react-aria";
import { cx, mergeRefs } from "../../utils/dom";
import { Field, FieldComponentProps } from "../form/field";

export type TextInputProps = AriaTextFieldProps & FieldComponentProps<"input">;

export function Input({
  className,
  classNames,
  style,
  styles,
  onChange,
  inputRef,
  ...props
}: TextInputProps) {
  const internalInputRef = React.useRef<HTMLInputElement>(null);

  const { labelProps, inputProps, errorMessageProps, descriptionProps } =
    useTextField(
      {
        ...props,
        onChange,
        inputElementType: "input",
      },
      internalInputRef
    );

  return (
    <Field
      labelProps={labelProps}
      descriptionProps={descriptionProps}
      errorMessageProps={errorMessageProps}
      className={className}
      classNames={classNames}
      styles={styles}
      style={style}
      {...props}
    >
      <input
        ref={mergeRefs(inputRef, internalInputRef)}
        data-has-left-addon={!!props.prepend}
        data-has-right-addon={!!props.append}
        className={cx("p-text-input-el")}
        {...inputProps}
      />
    </Field>
  );
}
